// ============================================================================
// events.js — a tiny synchronous pub/sub bus used for narrative & UI beats
// (warlord slain, bastion captured, milestone reached, announcer lines).
// Not on a hot path — combat/AI talk directly. Listeners are called in order.
// ============================================================================

export class EventBus {
  constructor() {
    this.map = new Map(); // event name -> array of handlers
  }
  on(name, fn) {
    let arr = this.map.get(name);
    if (!arr) { arr = []; this.map.set(name, arr); }
    arr.push(fn);
    return () => this.off(name, fn);
  }
  off(name, fn) {
    const arr = this.map.get(name);
    if (!arr) return;
    const i = arr.indexOf(fn);
    if (i >= 0) arr.splice(i, 1);
  }
  emit(name, payload) {
    const arr = this.map.get(name);
    if (!arr) return;
    for (let i = 0; i < arr.length; i++) arr[i](payload);
  }
}

// Canonical event names.
export const EV = {
  SWING: 'swing',             // player started an attack { heavy }
  HIT: 'hit',                 // player landed a hit  { x,z,damage,kill,reaction }
  KILL: 'kill',               // an enemy died        { x,z,team,type,byPlayer }
  PLAYER_HURT: 'playerHurt',  // player took damage   { damage }
  COMBO: 'combo',             // combo counter changed{ count }
  MILESTONE: 'milestone',     // kill milestone       { total }
  TITAN_READY: 'titanReady',
  TITANFALL: 'titanfall',
  BASTION_CAPTURED: 'bastionCaptured', // { bastion, team }
  WARLORD_ENGAGED: 'warlordEngaged',   // { warlord }
  WARLORD_SLAIN: 'warlordSlain',       // { warlord, team }
  MORALE: 'morale',           // morale changed       { value }
  ANNOUNCE: 'announce',       // grimdark banner text { text, tone }
  OBJECTIVE: 'objective',     // objective ticker text { text }
  BARK: 'bark',               // in-battle dialogue toast { who, line }
  PING: 'ping',               // minimap event pulse  { x, z, tone, kind }
  BATTLE_START: 'battleStart', // a fresh battle was loaded (reset transient UI)
  VICTORY: 'victory',
  DEFEAT: 'defeat',
};
